<div style="display: flex; align-items: center;">
  <button
    rdxSwitchRoot
    class="ds-toggle-xs"
    [id]="$id()"
    [value]="$_value() ?? false"
    [disabled]="$_disabled()"
    [checked]="$_value() ?? false"
    (onCheckedChange)="onToggleChange($event)"
  >
    <span rdxSwitchThumb class="ds-toggle-thumb-xs"></span>
  </button>
  <label class="ds-toggle-label ds-ml100" rdxLabel [for]="$id()">{{ $text() }}</label>
</div>

